import type { FaireProductEntity } from "../../entity_types/product";

export const p_56tp7i6lxy: FaireProductEntity = {
  token: "p_56tp7i6lxy",
  type: "product",
  name: "Orange Cinnamon Plant-Powered Lozenges",
  brandToken: "b_dsnudsdke8",
  brandName: "Essential Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/3fd930c9038996cbfe19965ac46e710da12ac2734c8b7c645ec9c1afe6f297af.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e23a2be443d9f63ac7ac00ff2f2399c2244086fa336d90c59f01aa03c89da6f2.jpeg",
    "https://cdn.faire.com/fastly/d73ae28b08ed4ef3f79cfe3b7ae63abd7371203be97cabc8355ab56d8c94758e.png",
    "https://cdn.faire.com/fastly/04f020d0f4f743f98812d985d0a580d0a2084fff779bb32b6793eac67dc94a70.jpeg",
    "https://cdn.faire.com/fastly/a9ea49ce0b3f089b054508a4d6498e7211c42012e6588cfbcbaf23fd81d5a6d5.jpeg",
    "https://cdn.faire.com/fastly/23a43177cad4657dec0cbba1fce7fadb5aa2efda38f07b33b2e81c8c1b6fc684.jpeg",
  ],
  priceDollars: 9.63,
  description:
    "Orange Cinnamon Plant-Powered Lozenges\n(formerly Happy Heart Blend™)\nNow USDA Organic Certified, Gluten-Free Certified, Vegan Certified\n\nSavor the uplifting citrus of orange and the warming spice of cinnamon in our Orange Cinnamon Plant-Powered Lozenges. This flavorful fusion brings together two time-honored botanicals, offering both comfort and vitality in every piece.\n\n🍊 Bright Orange – Bursting with citrus flavor, orange is naturally rich in antioxidants that help support overall wellness and vitality.\n🌿 Warm Cinnamon – A spice treasured for centuries, cinnamon offers a soothing, comforting taste and has been traditionally valued for promoting balance and wellbeing.\n\nCrafted with organic ingredients, this supportive hard candy delivers a delicious way to enjoy plant-powered wellness, blending refreshing citrus with cozy spice for a sweet daily ritual.",
  tags: [],
  msrpDollars: 19.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:17.908Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
